import Progress from "../ValueObject/Progress";
import {DownloadProgress, PartialDownloadProgress} from "../../../types/downloadManager";

export default class CreateProgressDownload {
    private static readonly SECONDS_IN_HOUR = 3600;
    private static readonly SECONDS_IN_MINUTE = 60;

    public create(request: DownloadProgress): Progress {
        return new Progress(
            this.calculatePercentage(request),
            request.total,
            request.downloaded,
            request.speed,
            this.calculateTime(request)
        );
    }

    public fromPartial(partial: PartialDownloadProgress): Progress {
        return new Progress(
            this.calculatePercentage(partial),
            partial.total,
            partial.downloaded,
            partial.speed,
            this.calculateTime(partial)
        );
    }

    private calculatePercentage(request: DownloadProgress | PartialDownloadProgress): number {
        return Math.floor(request.percentage * 100);
    }

    private calculateTime(request: DownloadProgress | PartialDownloadProgress): string {
        const totalSeconds = this.calculateTotalSeconds(request);
        const timeHours = this.calculateHours(totalSeconds);
        const timeMinutes = this.calculateMinutes(totalSeconds);
        const timeSeconds = this.calculateSeconds(totalSeconds);

        return this.formatTime(timeHours)
            + ':'
            + this.formatTime(timeMinutes)
            + ':'
            + this.formatTime(timeSeconds);
    }

    private calculateTotalSeconds(request: DownloadProgress | PartialDownloadProgress): number {
        const totalDownloaded: number = request.totalBytes - request.downloadedBytes;
        const calculateTime: number = totalDownloaded / request.speedBytes;

        return Math.round(calculateTime);
    }

    private calculateHours(totalSeconds: number): number {
        return Math.floor(totalSeconds / CreateProgressDownload.SECONDS_IN_HOUR);
    }

    private calculateMinutes(totalSeconds: number): number {
        const totalMinutes = (totalSeconds % CreateProgressDownload.SECONDS_IN_HOUR);

        return Math.floor(totalMinutes / CreateProgressDownload.SECONDS_IN_MINUTE);
    }

    private calculateSeconds(totalSeconds: number): number {
        const totalMinutes = (totalSeconds % CreateProgressDownload.SECONDS_IN_HOUR);

        return totalMinutes % CreateProgressDownload.SECONDS_IN_MINUTE;
    }

    private formatTime(time: number): string {
        return isNaN(time) ? '00' : String(time).padStart(2, '0');
    }
}